import { Info } from '@mui/icons-material';
import { Box } from '@mui/material';
import { visuallyHidden } from '@mui/utils';
import type { FormikProps } from 'formik';
import {
  DetailAccordion,
  DetailAccordionDetails,
  DetailAccordionSummary,
} from '~/components/DetailAccordion';
import { Tooltip } from '~/components/Tooltip';
import { OptionField } from '../components';
import type { AppEditor__GroupedTemplateParams as GroupedParams } from '../gql';
import type { FormValues } from '../lib';

interface AppFormParamGroupsProps {
  contentItemId?: number;
  formik: FormikProps<FormValues>;
  groupedParams: readonly GroupedParams[] | null | undefined;
}

export const AppFormParamGroups = ({
  contentItemId,
  formik,
  groupedParams,
}: AppFormParamGroupsProps) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {groupedParams?.map(({ paramGroup, params }, groupIndex) => {
        const details = (
          <DetailAccordionDetails key={groupIndex}>
            {params.map((param) => (
              <OptionField
                contentItemId={contentItemId}
                formik={formik}
                templateParamId={param.id}
                key={param.id}
              />
            ))}
          </DetailAccordionDetails>
        );

        if (paramGroup == null) return details;

        return (
          <DetailAccordion key={groupIndex}>
            <DetailAccordionSummary>
              {paramGroup.label}
              {paramGroup.description && (
                // The summary is itself a button, so the description is read as part of it
                // rather than through a nested control; the tooltip serves the pointer.
                <>
                  <Tooltip title={paramGroup.description}>
                    <Info color="secondary" fontSize="small" />
                  </Tooltip>
                  <span style={visuallyHidden}>{paramGroup.description}</span>
                </>
              )}
            </DetailAccordionSummary>
            {details}
          </DetailAccordion>
        );
      })}
    </Box>
  );
};
